const SOCIALMEDIA = {
    "Instagram": "mdi-instagram",
    "Facebook": "mdi-facebook",
    "Twitter": "mdi-twitter",
    "Youtube": "mdi-youtube"
}

export default SOCIALMEDIA